import {Grid, TextField, InputAdornment, FormControl, InputLabel, Select, OutlinedInput, MenuItem, Box, Button, Typography, IconButton, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { t } from "i18next";
import React, { useEffect, useState,useRef } from "react";
import DownloadButton from "../../common/DownloadBtn";
import CommonButton from "../../common/Button";
import MUIDataTable from "mui-datatables";
import Skeleton from "../../common/Skeleton";
import { useAppSelector } from "../../../redux/hooks";
import CONSTANTS, { BUSINESS_REPORT, LIST_LIMIT, SHEET_NAME } from "../../../constants/constants";
import { Link } from "react-router-dom";
import BusinessReportDataApi from "../services/businessReportService";
import Pagination from "../../common/Pagination";
import Utility from "../../../utils/Utility";
import { ProductLevelDataType, ProductLevelDataWithPaginationType } from "../../../interfaces/businessReportInterface";
import SearchIcon from "@mui/icons-material/Search";
import lazyTypingUtils from "../../../utils/lazyTypingUtils";
import downloadDataToExcel from "../../../utils/ExcelDownloadUtility";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import FavouriteIcon from "../../common/FavouriteIcon";
import ProductListApi from "../../BulkProductUpload/services/productList";
import { SearchIconButton } from "../../../utils/searchUtils";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const productSearchLabelKeys: Record<string, string> = {
    productCode: "product_code",
    cainzProductCode: "cainz_product_code",
    productName: "product_name",
};

const categorySearchLabelKeys: Record<string, string> = {
    categoryCode: "category_code",
    categoryName: "category_name",
};

const ProductReport = (props:any) => {
    const { showSnackbar,valueFrom,valueTo,activeViewBy } = props;

    const firstPage = 1;
    const moduleId = CONSTANTS.SALES_MANAGEMENT_MODULE_ID;
    const apiData: any[][] = [];
    const utility = new Utility();
    const perPageLimit = useAppSelector((state) => state.common.perPageLimit);
    const productListCurrentPage = useAppSelector((state:any) => state?.common?.productList);
    const [skeleton, setSkeleton] = useState(false);
    const [appliedFilter1, setAppliedFilter1] = useState<any>("none");
    const [search, setSearch] = useState<string>("");
    const [productSearchType, setProductSearchType] = useState("productCode");
    const [categorySearchType, setCategorySearchType] = useState("categoryCode");
    const [quantity, setQuantity] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [colFilter,setColFilter] = useState<string>("");
    const [direction,setDirection] = useState<string>("");
    const [limit, setLimit] = useState(!perPageLimit ? LIST_LIMIT.BULK_PRODUCT_LIST : perPageLimit );
    const isDemoUser = useAppSelector((state) => state.common.demoUser) ?? false;
    const [productLevelData, setProductLevelData] = useState<ProductLevelDataType[]>();
    const [currentPage, setCurrentPage] = useState(productListCurrentPage?.currentPage ?? 1);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const startDate = valueFrom ? utility.getFormattedDateTime(valueFrom) : null;
    const endDate = valueTo ? utility.getFormattedDateTime(valueTo) : null;
    const [isSearchChange,setIsSearchChange]=useState<boolean>(false);
    const [category, setCategory] = useState<string>("");
    const [isSearchCategory, setIsSearchCategory] = useState<boolean>(false);
    const [isSearchQuantity, setIsSearchQuantity] = useState<boolean>(false);
    const [hideColumnArr,setHideColumnArr] =useState<any>([]);
    const [hiddenTableColumns, setHiddenTableColumns] = useState<string[]>([]);
    const [showDownloadOptions , setShowDownloadOptions]=useState<boolean>(false);
    const node = useRef<HTMLDivElement>(null);
    const sortEffectInitializedRef = useRef(false);
    const requestIdRef = useRef(""); // tracks the latest call's UUID; stale GET/HEAD responses check against this before updating state
    const countRequestIdRef = useRef("");
    const countRequestTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const [isCountLoading, setIsCountLoading] = useState(false); // HEAD is slower than GET; keep download disabled until fresh count arrives
    const [nextPage, setNextPage] = useState(false);
    const [favorite, setFavorite] = useState<any>("none");
    const [totalOrderValue, setTotalOrderValue] = useState<string>("");
    const [isTotalOrderValueSearch,setIsTotalOrderValueSearch]=useState<boolean>(false);
    const [fullWidthL, setFullWidthL] = useState<number>(0);
    const [resetKey, setResetKey] = useState(0);


    // Fires when filters, date range, or viewBy change — these affect which records match,
    // so a fresh HEAD count is required alongside the data fetch.
    useEffect(() => {
        if (!startDate || !endDate || !activeViewBy) return;
        productLevelDataApiCall(firstPage, limit);
    }, [startDate, endDate, activeViewBy, appliedFilter1, favorite, resetKey]);

    // Fires only when sort column or direction changes — sorting reorders existing rows
    // so the total count never changes; skip HEAD and fetch data only.
    // Skip only the initial empty-sort run; later empty-sort changes still need to refresh data.
    useEffect(() => {
        if (!startDate || !endDate || !activeViewBy) return;
        if (!sortEffectInitializedRef.current) {
            sortEffectInitializedRef.current = true;
            if (!colFilter) return;
        }
        productLevelDataApiCall(firstPage, limit, false);
    }, [colFilter, direction]);

    const handleSearchIconClick = () =>{
        setIsSearchChange(false);
        productLevelDataApiCall(firstPage, limit);
    };

    const handleProductSearchTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const nextSearchType = e.target.value;
        if (nextSearchType === productSearchType) return;

        setProductSearchType(nextSearchType);
        setIsSearchChange(Boolean(search.trim()));
        setSearch("");
    };

    const handleSearchChange = (e: any) => {
        setIsSearchChange(true);
        const { value } = e.target;
        setSearch(value);
    };

    const onsearchApicall = () =>{
        if(isSearchChange){
            productLevelDataApiCall(firstPage, limit);
        }
    };
    
    const propItem = [
        onsearchApicall,search
    ];
    lazyTypingUtils(propItem);

    const handleCategorySearchChange = (e: any) => {
        setIsSearchCategory(true);
        const { value } = e.target;
        setCategory(value);
    };

    const handleCategorySearchTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const nextSearchType = e.target.value;
        if (nextSearchType === categorySearchType) return;

        setCategorySearchType(nextSearchType);
        setIsSearchCategory(Boolean(category.trim()));
        setCategory("");
    };

    const handleCategorySearchClick = () =>{
        setIsSearchCategory(false);
        productLevelDataApiCall(firstPage, limit);
    };

    const onCategorySearchApicall = () =>{
        if(isSearchCategory){
            productLevelDataApiCall(firstPage, limit);
        }
    };
    
    const categorySearchPropItem = [
        onCategorySearchApicall,category
    ];
    lazyTypingUtils(categorySearchPropItem);

    const handleQuantitySearchChange = (e: any) => {
        setIsSearchQuantity(true);
        const { value } = e.target;
        setQuantity(value);
    };

    const onQuantitySearchApicall = () =>{
        if(isSearchQuantity){
            productLevelDataApiCall(firstPage, limit);
        }
    };
    
    const QuantitySearchPropItem = [
        onQuantitySearchApicall,quantity
    ];
    lazyTypingUtils(QuantitySearchPropItem);

    const handleSorting = (changedColumn: string) => {
        setDirection(colFilter === changedColumn && direction === "ASC" ? "DESC" : "ASC");
        setColFilter(changedColumn);
    };

    const renderSortHeader = (label: React.ReactNode, columnName: string, marginTop?: string) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Box>{label}</Box>
            <IconButton color="primary" size="small" onClick={() => handleSorting(columnName)}sx={{ flex: "0 0 auto", ml: 0, mt: marginTop }}>
                {colFilter !== columnName ? (<SwapVertIcon className="swapVertIcon" />) : direction === "ASC"
                    ? (<ArrowUpwardIcon className="sortingIconPosition" />) : (<ArrowDownwardIcon className="sortingIconPosition" />)
                }
            </IconButton>
        </Box>
    );

    const buildSortString = (): string => {
        if (!colFilter) return "";
        const fieldMap: { [key: string]: string } = {
            date: "date",
            product_code: "productCode",
            cainz_product_code: "cainzProductCode",
            product_name: "productName",
            category_details: "categoryCode",
            sales_price: "productPrice",
            individual_shipping_fee: "individualShippingFee",
            sales_amount: "totalSalesAmount",
            sales_volume: "salesVolume",
            number_of_returns: "productReturnQuantity",
            available_stock_quantity: "freeInventoryQuantity",
        };
        return `${fieldMap[colFilter]}:${direction.toUpperCase() || "ASC"}`;
    };

    const isColumnVisible = (columnName: string) => !hiddenTableColumns.includes(columnName);
    const columns = [
        {
            name: t("business_report.date"),
            options: {
                filter: true,
                sort: false,
                viewColumns: false,
                customHeadLabelRender: (data:any) => {
                    return renderSortHeader(data.label, "date");
                },
                setCellHeaderProps: () => ({ style:{ minWidth: "70px" } }),
            },
        },
        {
            name: t("business_report.product_code"),
            options: {
                filter: true,
                sort: false,
                display: isColumnVisible(t("business_report.product_code")),
                setCellProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 150,
                    },
                }),
                customHeadLabelRender: (data:any) => {
                    return (
                        <Box sx={{ display: "flex", alignItems: "baseline", gap: 1 }}>
                            <Typography>
                                <IconButton sx={{pointerEvents:"none"}}>
                                    <StarOutlineIcon />
                                </IconButton>
                            </Typography>
                            <Typography>
                                {renderSortHeader(data.label, "product_code")}
                            </Typography>
                        </Box>
                    );
                },
                setCellHeaderProps: () => ({ style: { minWidth: "160px" } }),
            },
        },
        {
            name: t("business_report.cainz_product_code"),
            options: {
                filter: true,
                sort: false,
                display: isColumnVisible(t("business_report.cainz_product_code")),
                customHeadLabelRender: (data:any) => {
                    return renderSortHeader(data.label, "cainz_product_code");
                },
                setCellHeaderProps: () => ({ style:{ minWidth: "180px" } }),
            },
        },
        {
            name: t("business_report.product_name"),
            options: {
                filter: true,
                sort: false,
                display: isColumnVisible(t("business_report.product_name")),
                setCellProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 150,
                    },
                }),
                customHeadLabelRender: (data:any) => {
                    return renderSortHeader(data.label, "product_name");
                },
                setCellHeaderProps: () => ({ style:{ minWidth: "120px" } }),
            },
        },
        {
            name: t("business_report.category_details"),
            options: {
                filter: true,
                sort: false,
                display: isColumnVisible(t("business_report.category_details")),
                setCellProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 150,
                    },
                }),
                customHeadLabelRender: (data:any) => {
                    return renderSortHeader(data.label, "category_details");
                },
                setCellHeaderProps: () => ({ style:{ minWidth: "140px" } }),
            },
        },
        {
            name: t("business_report.public_flag"),
            options: {
                filter: true,
                sort: false,
                display: isColumnVisible(t("business_report.public_flag")),
                customHeadLabelRender: (data: any) => (
                    <Typography sx={{ whiteSpace: "pre-line", fontWeight:500}}>
                        {String(data.label).replace(/\s+/g, "\n")}
                    </Typography>
                ),
                setCellHeaderProps: () => ({ style:{ minWidth: "45px" } }),
            },
        },
        {
            name: t("business_report.release_end_date_of_publication"),
            options: {
                filter: true,
                sort: false,
                display:isColumnVisible(t("business_report.release_end_date_of_publication")),
                customHeadLabelRender: (data: any) => (
                    <Typography sx={{ whiteSpace: "pre-line", fontWeight:500}}>
                        {String(data.label).replace(/\s+/g, "\n")}
                    </Typography>
                ),
                setCellHeaderProps: () => ({ style:{ minWidth: "80px" } }),
            },
        },
        {
            name: t("business_report.sales_price"),
            options: {
                filter: true,
                sort: false,
                display: isColumnVisible(t("business_report.sales_price")),
                customHeadLabelRender: (data:any) => {
                    return renderSortHeader(data.label, "sales_price");
                },
                setCellHeaderProps: () => ({ style:{ minWidth: "130px" } }),
            },
        },
        {
            name: t("business_report.individual_shipping_fee"),
            options: {
                filter: true,
                sort: false,
                display: isColumnVisible(t("business_report.individual_shipping_fee")),
                customHeadLabelRender: (data:any) => {
                    return renderSortHeader(
                        <Typography sx={{ whiteSpace: "pre-line", fontWeight:500}}>
                            {String(data.label).replace(/\s+/g, "\n")}
                        </Typography>,
                        "individual_shipping_fee",
                        "-15px"
                    );
                },
                setCellHeaderProps: () => ({ style:{ minWidth: "70px" } }),
            },
        },
        {
            name: t("business_report.sales_volume"),
            options: {
                filter: true,
                sort: false,
                display: isColumnVisible(t("business_report.sales_volume")),
                customHeadLabelRender: (data:any) => {
                    return renderSortHeader(data.label, "sales_volume");
                },
                setCellHeaderProps: () => ({ style:{ minWidth: "80px" } }),
            },
        },
        {
            name: t("business_report.number_of_returns"),
            options: {
                filter: true,
                sort: false,
                display: isColumnVisible(t("business_report.number_of_returns")),
                customHeadLabelRender: (data:any) => {
                    return renderSortHeader(data.label, "number_of_returns");
                },
                setCellHeaderProps: () => ({ style:{ minWidth: "80px" } }),
            },
        },
        {
            name: t("business_report.sales_amount"),
            options: {
                filter: true,
                sort: false,
                display: isColumnVisible(t("business_report.sales_amount")),
                customHeadLabelRender: (data:any) => {
                    return renderSortHeader(data.label, "sales_amount");
                },
                setCellHeaderProps: () => ({ style:{ minWidth: "80px" } }),
            },
        },
        {
            name: t("business_report.available_stock_quantity"),
            options: {
                filter: true,
                sort: false,
                display: isColumnVisible(t("business_report.available_stock_quantity")),
                customHeadLabelRender: (data:any) => {
                    return renderSortHeader(
                        <Typography sx={{ whiteSpace: "pre-line", fontWeight:500}}>
                            {String(data.label).replace(/\s+/g, "\n")}
                        </Typography>,
                        "available_stock_quantity",
                        "-15px"
                    );
                },
                setCellHeaderProps: () => ({ style:{ minWidth: "80px" } }),
            },
        },
    ];

    const productLevelDataApiCall = (currentPage: number, limit: number, fetchCount = true) => {
        setShowDownloadOptions(false);
        setIsSearchChange(false);
        setIsTotalOrderValueSearch(false);
        if (fetchCount) {
            setNextPage(false);
            setIsCountLoading(true);
            if (countRequestTimerRef.current) {
                clearTimeout(countRequestTimerRef.current);
            }
        }
        const payload = {};
        const isHitDummyURL = false;
        setSkeleton(true);
        const sortStr = buildSortString();
        const api = new BusinessReportDataApi(payload, isHitDummyURL);

        // UUID is unique per call and per mount — prevents a stale response from a
        // previous call (or a previous mount cycle) from overwriting current state.
        const callId = crypto.randomUUID();
        requestIdRef.current = callId;
        if (fetchCount) {
            countRequestIdRef.current = callId;
        }

        // Both GET and HEAD receive the same filters so X-Total-Count always matches
        // the data being displayed. Add any new filter here once; it applies to both.
        const filterArgs = [
            activeViewBy, startDate, endDate,
            search.trim(), category.trim(), quantity.trim(),
            sortStr, appliedFilter1, favorite, totalOrderValue.trim(),
            productSearchType, categorySearchType
        ] as Parameters<typeof api.productLevelDataCount>;

        // GET resolves faster (~3s) — show data immediately without waiting for HEAD.
        api.productLevelData(currentPage, limit, ...filterArgs, fetchCount)
            .then((res: ProductLevelDataWithPaginationType) => {
                // Discard response if a newer call has already taken over.
                if (callId !== requestIdRef.current) return;
                setProductLevelData(res?.productLevelDataLogs);
                setNextPage(res?.nextPage === true);
                // setLimit is intentionally omitted — Pagination drives it via rowsPerPageChange.
                // Setting it here would revert a rows-per-page change made while this GET was in-flight.
                setCurrentPage(currentPage);
                setSkeleton(false);
            })
            .catch((err: unknown) => {
                showSnackbar((err as Error)?.message, false);
                setSkeleton(false);
            });

        if (fetchCount) {
            // HEAD resolves slower (~12s) — update count in the background without blocking the table.
            api.productLevelDataCount(...filterArgs)
                .then((count: number) => {
                    // Discard if a newer call has already updated the count.
                    if (callId !== countRequestIdRef.current) return;
                    setTotalCount(count);
                    setTotalPages(Math.ceil(count / limit));
                    setIsCountLoading(false);
                })
                .catch((err: unknown) => {
                    if (callId !== countRequestIdRef.current) return;
                    setIsCountLoading(false);
                    showSnackbar((err as Error)?.message, false);
                });
        } else {
            // Page/sort/limit changes do not affect which records match the filters,
            // so the total count is unchanged — recalculate pages from the cached value.
            setTotalPages(Math.ceil(totalCount / limit));
        }

        apiTableData();
    };

    const productNameLink = (name: any, id:string | undefined,isDemoUser:boolean) => {
        return (
            (isDemoUser) ? name : (<Link to={`${process.env.REACT_APP_PRODUCT_BASE_URL}/${id}.html`} target="_blank" rel="noopener noreferrer" className="Order_id_link">
                {name}
            </Link>)
        );
    };

    const businessReportColorValue = (amount: any) => {
        return (
            <Box className={`${amount < 0 ? "business_report_red" : "business_report_black"}`}>{new Utility().numberWithCommas(amount)}</Box>
        );
    };

    const favoriteFlag =(productCode: any, isFavourite: boolean)=>{
        return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography textAlign={"center"}>
                    <FavouriteIcon
                        isFavourite={isFavourite}
                        onClick={(current) => favouriteProductApiCall(productCode, current)}
                    />
                </Typography>
                <Typography>
                    {productCode}
                </Typography>
            </Box>
        );
    };
    const apiTableData = () => {
        {
            productLevelData?.map((item: ProductLevelDataType, index: number) => {
                apiData[index] = [];
                const isFav = item?.favorite === 1;
                apiData[index].push(
                    // (currentPage - 1) * limit + index + 1,
                    item?.date,
                    favoriteFlag(item?.productCode,isFav),
                    item?.cainzProductCode,
                    productNameLink(item?.productName, item?.cainzProductCode,isDemoUser),                  
                    <>
                        {item?.categoryCode}
                        <br />
                        {item?.categoryName}
                    </>,
                    item?.publicFlag,
                    <>
                        {item?.publishingStartDate}
                        <br />
                        {item?.publishingEndDate}
                    </>,
                    item?.productPrice,
                    item?.individualShippingFee,
                    item?.salesVolume,
                    item?.productReturnQuantity,
                    businessReportColorValue(item?.totalSalesAmount),
                    businessReportColorValue(item?.freeInventoryQuantity)
                    
                );
            });
        }
    };
    apiTableData();

    const handleQuantitySearchClick = () =>{
        setIsSearchChange(false);
        productLevelDataApiCall(firstPage, limit);
    };
    const resetAllFilters = () =>{
        setSearch("");
        setCategory("");
        setProductSearchType("productCode");
        setCategorySearchType("categoryCode");
        setQuantity("");
        setAppliedFilter1("none");
        setFavorite("none");
        setTotalOrderValue("");
        setIsSearchChange(false);
        setIsSearchCategory(false);
        setIsSearchQuantity(false);
        setIsTotalOrderValueSearch(false);
        setResetKey((previousKey) => previousKey + 1);
    };

    const downloadProductLevelData = (startDate:string | null, endDate:string | null, fileType:string) => {
        setShowDownloadOptions(false);
        showSnackbar(t("bulk_product_index.download_started"), true);
        const payload = {};
        const isHitDummyURL = false;
        setLoading(true);
        const sortStr = buildSortString();
        new BusinessReportDataApi(payload, isHitDummyURL)
            .downloadProductLevelListData(startDate,endDate,fileType,search.trim(),category.trim(),quantity.trim(),sortStr,appliedFilter1,favorite,totalOrderValue.trim(),activeViewBy,totalCount,productSearchType,categorySearchType)
            .then((res) => {
                if(typeof res == "string"){
                    showSnackbar(res, true);
                    setLoading(false);
                } else {
                    handleOnExport(res?.productLevelDataLogs);
                }
            })
            .catch((err: any) => {
                setLoading(false);
                setSkeleton(false);
                showSnackbar(err?.message, false);
            });    
    };
        
    const handleOnExport = (downloadArray?: any) => {
        const downloadData: Array<object> = [];
        const formattedStartDate = startDate ? startDate.replaceAll("/", "") : "";
        const formattedEndDate = endDate ? endDate.replaceAll("/", "") : "";
        downloadArray?.map((item: any) => {
            downloadData.push({
                日付:item?.date,
                商品コード:item?.productCode,
                カインズ商品コード:item?.cainzProductCode,
                商品名:item?.productName,
                カテゴリコード:item?.categoryCode,
                カテゴリ名:item?.categoryName,
                公開フラグ:item?.publicFlag,
                公開開始日:item?.publishingStartDate,
                公開終了日:item?.publishingEndDate,
                税込商品価格:item?.productPrice,
                個別送料:item?.individualShippingFee,
                販売数:item?.salesVolume,
                返品数:item?.productReturnQuantity,
                受注額:item?.totalSalesAmount,
                フリー在庫数:item?.freeInventoryQuantity,
            });
        });   
        const fileName = `商品別売上データ_${formattedStartDate}-${formattedEndDate}.xlsx`; 
        const numFmt="text";
        const allignment = true;
        downloadDataToExcel(downloadData,fileName,SHEET_NAME.PRODUCT_DATA,numFmt,allignment,BUSINESS_REPORT.ROW_HEIGHT);
        setLoading(false);
    };

    const handleFlagFilterChange = (e: any) => {
        const { value } = e.target;
        setAppliedFilter1(value);
    };

    useEffect(() => {
        const handleClickOutside = (event: { target: any; }) => {
            if (node.current && !node.current.contains(event.target)) {
                setShowDownloadOptions(false);
                   
            } 
        };              
        document.addEventListener("mousedown", handleClickOutside);       
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const handleFavouriteFilter = (e: any) => {
        const { value } = e.target;
        setFavorite(value);
    };

    const favouriteProductApiCall = (productCode: any, isFavourite: boolean) => {
        const payload = {
            favoriteFlag: (!isFavourite ? CONSTANTS.FAVORITE_FLAG : CONSTANTS.NOT_FAVORITE_FLAG).toString()
        };
        const headers = {
            moduleId: moduleId,
        };
        const isHitDummyURL = false;
        new ProductListApi(payload, isHitDummyURL, headers).favouriteProduct(productCode, !isFavourite).then((res) => {
            showSnackbar(res, true);
            productLevelDataApiCall(currentPage, limit);
        }).catch((err) => {
            showSnackbar(err.message, false);
        });
    };

    const handleTotalOrderValueSearch = (e: any) => {
        setIsTotalOrderValueSearch(true);
        const { value } = e.target;
        setTotalOrderValue(value);
    };

    const handleInputType = (e: any,isCount?:number) => {
        let inputValue = e.target.value.replace(/[^0-9０-９]/g, "");
        inputValue = inputValue.replace(/[０-９]/g, function(m: any) {
            return String.fromCharCode(m.charCodeAt(0) - 0xfee0);
        });
        inputValue = inputValue.slice(0, isCount);
        e.target.value = inputValue;
    };

    const onTotalOrderValueSearch = () =>{
        if(isTotalOrderValueSearch){
            productLevelDataApiCall(firstPage, limit);
        }
    };
    
    const totalOrderValuePropItem = [
        onTotalOrderValueSearch,totalOrderValue
    ];
    lazyTypingUtils(totalOrderValuePropItem);


    return (
        <Grid>
            <Grid container justifyContent={"space-between"} gap={2}>

                <Grid container spacing={2} lg={10} md={12} sm={12} xs={12} gap={2} mt={0} >
                        
                    <Grid container xs={12} sm={6} md={12} lg={12} spacing={2} >
                        <Grid item xs={12} md={6} lg={6}>
                            <Box sx={{ border: "1px solid #9ccfc8", borderRadius: 1, p: 1.25, backgroundColor: "#f7fbfa" }}>
                                <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
                                    {t("business_report.product_search")}
                                </Typography>
                                <RadioGroup
                                    row
                                    value={productSearchType}
                                    onChange={handleProductSearchTypeChange}
                                    sx={{
                                        flexWrap: "wrap",
                                        mb: 0.5,
                                        "& .MuiFormControlLabel-root": { mr: 2, ml: 0 },
                                    }}
                                >
                                    <FormControlLabel value="productCode" control={<Radio size="small" />} label={t("business_report.product_code")} />
                                    <FormControlLabel value="cainzProductCode" control={<Radio size="small" />} label={t("business_report.cainz_product_code")} />
                                    <FormControlLabel value="productName" control={<Radio size="small" />} label={t("business_report.product_name")} />
                                </RadioGroup>
                                <TextField
                                    placeholder={`${t("business_report.search_by_type_placeholder", { type: t(`business_report.${productSearchLabelKeys[productSearchType]}`) }) ?? ""}`}
                                    onChange={handleSearchChange}
                                    value={search}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={handleSearchIconClick}>
                                                    <SearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    sx={{ backgroundColor: "background.paper" }}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={6} lg={6}>
                            <Box sx={{ border: "1px solid #9ccfc8", borderRadius: 1, p: 1.25, backgroundColor: "#f7fbfa" }}>
                                <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
                                    {t("business_report.category_search")}
                                </Typography>
                                <RadioGroup
                                    row
                                    value={categorySearchType}
                                    onChange={handleCategorySearchTypeChange}
                                    sx={{
                                        flexWrap: "wrap",
                                        mb: 0.5,
                                        "& .MuiFormControlLabel-root": { mr: 2, ml: 0 },
                                    }}
                                >
                                    <FormControlLabel value="categoryCode" control={<Radio size="small" />} label={t("business_report.category_code")} />
                                    <FormControlLabel value="categoryName" control={<Radio size="small" />} label={t("business_report.category_name")} />
                                </RadioGroup>
                                <TextField
                                    placeholder={`${t("business_report.search_by_type_placeholder", { type: t(`business_report.${categorySearchLabelKeys[categorySearchType]}`) }) ?? ""}`}
                                    onChange={handleCategorySearchChange}
                                    value={category}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={handleCategorySearchClick}>
                                                    <SearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    sx={{ backgroundColor: "background.paper" }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                        
                    <Grid container xs={12} sm={6} md={12} lg={12} spacing={2}>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                label={t("business_report.search_by_total_order_value")}
                                onChange={handleTotalOrderValueSearch}
                                value={totalOrderValue}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIconButton
                                                setIsSearchChange={setIsTotalOrderValueSearch}
                                                apiCallFunction={productLevelDataApiCall}
                                                page={currentPage}
                                                limit={limit}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                onInput={(e) => handleInputType(e,CONSTANTS.MAX_LIMIT_TOTAL_ORDER_VALUE)}   
                                variant="outlined"
                                fullWidth
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                label={t("business_report.search_by_quantity")}
                                onChange={handleQuantitySearchChange}
                                value={quantity}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleQuantitySearchClick}>
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                onInput={(e) => handleInputType(e,CONSTANTS.MAX_LIMIT_SEARCH_BY_QUANTITY)}
                                variant="outlined"
                                fullWidth
                                size="small"
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3} lg={2}>
                            <FormControl size="small" fullWidth>
                                <InputLabel id="favorite-filter-label">{t("product_list.favorite")}</InputLabel>
                                <Select
                                    id="favorite-filter-select"
                                    size="small"
                                    value={favorite}
                                    onChange={(e) => handleFavouriteFilter(e)}
                                    fullWidth
                                    input={<OutlinedInput label={t("product_list.favorite")} />}
                                >
                                    <MenuItem value={"1"}>
                                        {t("business_report.filter_by_favorite")}
                                    </MenuItem>
                    
                                    <MenuItem value={"none"}>
                                        {t("product_list.all")}
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3} lg={2}>
                            <FormControl size="small" fullWidth>
                                <InputLabel id="demo-multiple-name-label">
                                    {t("bulk_product_index.public_flag")}
                                </InputLabel>
                                <Select
                                    id="demo-simple-select"
                                    size="small"
                                    value={appliedFilter1}
                                    onChange={(e) => handleFlagFilterChange(e)}
                                    fullWidth
                                    input={
                                        <OutlinedInput label={t("bulk_product_index.public_flag")} />
                                    }>
                                            
                                    <MenuItem value="0">{t("bulk_product_index.private")}</MenuItem>
                                    <MenuItem value="1">{t("bulk_product_index.public")}</MenuItem>
                                    <MenuItem value="none">{t("bulk_product_index.all")}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>                        
                    </Grid>
                                        
                </Grid>

                <Grid container lg={2} md={12} sm={12} xs={12}  ref={node} >
                    <Grid item xs={12} sm={6} md={3} lg={4.5}>
                        <CommonButton
                            sx={{textTransform: "capitalize"}}
                            route={window.location.pathname}
                            functionToExecute={resetAllFilters}
                            btnName={t("pr.reset")} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={7} ref={node} >

                        {totalCount <= BUSINESS_REPORT.BUSINESS_REPORT_DOWNLOAD_LIMIT ? 
                            <DownloadButton loading={loading}  route={window.location.pathname} functionToExecute={()=>downloadProductLevelData(startDate,endDate,"xlsx")} className="product_list_download" btnName= {t("bulk_product_index.batch_download")} disableCondition={skeleton || loading || isCountLoading || productLevelData?.length == 0 || !productLevelData} />
                            : totalCount <= BUSINESS_REPORT.BUSINESS_REPORT_DOWNLOAD_LIMIT_CSV ?
                                <>
                                    <DownloadButton loading={loading}  route={window.location.pathname} functionToExecute={()=>setShowDownloadOptions(!showDownloadOptions)} className="wd_100" btnName= {t("bulk_product_index.batch_download")} disableCondition={skeleton || loading || isCountLoading || productLevelData?.length == 0 || !productLevelData}  endIconRequired={showDownloadOptions ? <ArrowDropUpIcon /> : <ArrowDropDownIcon/>} />
                                    {showDownloadOptions ?
                                        <><Box sx={{position:"relative"}}>
                                            <Button
                                                variant="contained"
                                                fullWidth
                                                sx={{marginTop:"1px",textTransform: "capitalize"}}
                                                className="product_list_Download_button margin_excel_download_product"
                                                disabled={skeleton ||  (totalCount <= BUSINESS_REPORT.BUSINESS_REPORT_DOWNLOAD_LIMIT_EXCEL ? false : true) }
                                                onClick={()=>downloadProductLevelData(startDate,endDate,"xlsx")}
                                            >
                                                <Box component={"span"} sx={{fontSize:16}}> 
                                                    {t("product_list.excel_download")} 
                                                    <Box component={"div"} sx={{fontSize:10}}>
                                                        {t("product_list.excel_download_limit")} 
                                                    </Box>
                                                </Box>
                                            </Button>
                                            <Button
                                                variant="contained"
                                                fullWidth
                                                sx={{ marginTop:"1px", textTransform: "capitalize"}}
                                                className="product_list_Download_button margin_csv_download_product"
                                                disabled={skeleton}
                                                onClick={()=>downloadProductLevelData(startDate,endDate,"csv")}
                                            >
                                                <Box component={"span"} sx={{fontSize:16}}>
                                                    {t("product_list.csv_download")}
                                                    <Box component={"div"} sx={{fontSize:10}}>
                                                        {t("product_list.csv_download_limit")}
                                                    </Box>
                                                </Box>                                                                                   
                                            </Button>
                                        </Box>
                                        </>
                                        : null
                                    }                              
                                </> 
                                :    
                                <>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        sx={{textTransform: "capitalize"}}
                                        endIcon={<ArrowDropDownIcon />}
                                        disabled={true}
                                    >
                                        {t("product_list.batch_download")}                                          
                                    </Button>
                                    <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "center", mt: 1 }}>
                                        <CancelOutlinedIcon className="cross_icon" />
                                        <Typography variant="body2" sx={{ textAlign: "left", lineHeight: 1.6 }}>
                                            {t("product_list.business_report_download_limit_exceed")}
                                        </Typography>
                                    </Box>
                                </>
                        }

                    </Grid>
                </Grid>
                
            </Grid>

            {skeleton ? (
                <Skeleton
                    varient="rectangular"
                    width={0}
                    height={60}
                    count="10"
                    my={0}
                />
            ) : (
                       
                <MUIDataTable
                    title={""}
                    columns={columns}
                    data={apiData}
                    options={{
                        pagination: false,
                        print: false,
                        download: false,
                        filter: false,
                        search: false,
                        selectableRowsHideCheckboxes: true,
                        textLabels: {
                            body: {
                                noMatch: t("table_text.no_match").toString(),
                            },
                            viewColumns: {
                                title: t("table_text.show_columns").toString(),
                                titleAria: "Show/Hide Table Columns",
                            },
                            toolbar: {
                                search: t("table_text.search").toString(),
                                viewColumns: t("table_text.view_columns").toString(),
                            },
                        },
                        searchPlaceholder: t("table_text.search_placeholder").toString(),
                        responsive: "standard",  
                        onViewColumnsChange: (changedColumn: string, action: string) => {
                            const columnNameToFilterKey: { [key: string]: string } = {
                                [t("business_report.date")]: "date",
                                [t("business_report.product_code")]: "product_code",
                                [t("business_report.cainz_product_code")]: "cainz_product_code",
                                [t("business_report.product_name")]: "product_name",
                                [t("business_report.category_details")]: "category_details",
                                [t("business_report.sales_price")]: "sales_price",
                                [t("business_report.individual_shipping_fee")]: "individual_shipping_fee",
                                [t("business_report.sales_volume")]: "sales_volume",
                                [t("business_report.number_of_returns")]: "number_of_returns",
                                [t("business_report.sales_amount")]: "sales_amount",
                                [t("business_report.available_stock_quantity")]: "available_stock_quantity",
                            };

                            if (action === "remove") {
                                setHiddenTableColumns((prevColumns) => prevColumns.includes(changedColumn) ? prevColumns : [...prevColumns, changedColumn]);

                                // Clear sorting when its active column is hidden.
                                const filterKey = columnNameToFilterKey[changedColumn];
                                if (filterKey === colFilter) {
                                    setColFilter("");
                                    setDirection("");
                                }
                            } else {
                                setHiddenTableColumns((prevColumns) => prevColumns.filter((column) => column !== changedColumn));
                            }
                            const tempHideColArr = [...hideColumnArr];

                            if (action === "remove") {
                                changedColumn == "Date" ?
                                    tempHideColArr.push("日付") :
                                    changedColumn == "Product Code" ?
                                        tempHideColArr.push("商品コード") :
                                        changedColumn == "Cainz Product Code" ?
                                            tempHideColArr.push("カインズ商品コード") :
                                            changedColumn == "Product Name" ?
                                                tempHideColArr.push("商品名") :
                                                changedColumn == "Category Detail" ?
                                                    tempHideColArr.push("カテゴリ詳細") :
                                                    changedColumn == "Public Flag" ?
                                                        tempHideColArr.push("公開フラグ") :
                                                        changedColumn == "Release/End Date of Publication" ?
                                                            tempHideColArr.push("公開開始日/公開終了日") :
                                                            changedColumn == "Sales Price" ?
                                                                tempHideColArr.push("税込商品価格") :
                                                                changedColumn == "Individual Shipping Fee" ?
                                                                    tempHideColArr.push("個別送料") :
                                                                    changedColumn == "Sales Amount" ?
                                                                        tempHideColArr.push("受注額") :
                                                                        changedColumn == "Sales Volume" ?
                                                                            tempHideColArr.push("販売数") :
                                                                            changedColumn == "Number of Returns" ?
                                                                                tempHideColArr.push("返品数") :
                                                                                changedColumn == "Available Stock Quantity" ?
                                                                                    tempHideColArr.push("フリー在庫数") :
                                                                                    tempHideColArr.push(changedColumn);

                                setHideColumnArr(tempHideColArr);
                            } else {
                                let index = -1;

                                changedColumn == "Date" ?
                                    index = tempHideColArr.indexOf("日付") :
                                    changedColumn == "Product Code" ?
                                        index = tempHideColArr.indexOf("商品コード") :
                                        changedColumn == "Cainz Product Code" ?
                                            index = tempHideColArr.indexOf("カインズ商品コード") :
                                            changedColumn == "Product Name" ?
                                                index = tempHideColArr.indexOf("商品名") :
                                                changedColumn == "Category Detail" ?
                                                    index = tempHideColArr.indexOf("カテゴリ詳細") :
                                                    changedColumn == "Public Flag" ?
                                                        index = tempHideColArr.indexOf("公開フラグ") :
                                                        changedColumn == "Release/End Date of Publication" ?
                                                            index = tempHideColArr.indexOf("公開開始日/公開終了日") :
                                                            changedColumn == "Sales Price" ?
                                                                index = tempHideColArr.indexOf("税込商品価格") :
                                                                changedColumn == "Individual Shipping Fee" ?
                                                                    index = tempHideColArr.indexOf("個別送料") :
                                                                    changedColumn == "Sales Amount" ?
                                                                        index = tempHideColArr.indexOf("受注額") :
                                                                        changedColumn == "Sales Volume" ?
                                                                            index = tempHideColArr.indexOf("販売数") :
                                                                            changedColumn == "Number of Returns" ?
                                                                                index = tempHideColArr.indexOf("返品数") :
                                                                                changedColumn == "Available Stock Quantity" ?
                                                                                    index = tempHideColArr.indexOf("フリー在庫数") :
                                                                                    index = tempHideColArr.indexOf(changedColumn);

                                tempHideColArr.splice(index,1);
                                setHideColumnArr(tempHideColArr);
                            }
                        }                          
                    }}                       
                />
            )}
            <Pagination
                totalCount={totalCount}
                currentPage={currentPage}
                pageChange={(page: number, lim: number) => productLevelDataApiCall(page, lim, false)}
                totalPage={totalPages}
                rowsPerPage={limit}
                rowsPerPageChange={setLimit}
                isCountLoading={isCountLoading}
                isPageLoading={skeleton}
                nextPage={nextPage}
                maxDisplayedCount={CONSTANTS.TOTAL_NUMBER_COUNT}
            />
        </Grid>
    );
};

export default ProductReport;